import React from 'react'
import { gql } from '@apollo/client'

import { usePublicProjectOverviewRequestAccessMutation as useMutation } from '~/common/types/graphql'
import FormDrawer from '~/views/components/FormDrawer'
import useProjectId from '~/views/hooks/useProjectId'

import RequestAccessForm from './RequestAccessForm'

interface Props {
  onClose(): void
}

const RequestAccessDrawer: React.FC<Props> = ({ onClose }) => {
  const projectId = useProjectId()
  const [requestAccess] = useMutation()

  const handleSubmit = async ({ email = '', name = '' }) => {
    if (!projectId) return
    await requestAccess({
      variables: {
        userData: {
          projectId,
          userEmail: email,
          userName: name,
        },
      },
    })

    onClose()
  }

  return (
    <FormDrawer
      onClose={onClose}
      title="Request Access"
      searchParam="request-access"
    >
      <RequestAccessForm onSubmit={handleSubmit} />
    </FormDrawer>
  )
}

// eslint-disable-next-line  no-unused-expressions
gql`
  mutation PublicProjectOverview_RequestAccess(
    $userData: submitRequestAccessInput!
  ) {
    submitRequestAccess(input: $userData) {
      success
    }
  }
`

export default RequestAccessDrawer
